<template>
    <div v-if="value" class="d-flex justify-center py-1">
        <div class="d-flex flex-column justify-center" :style="{width: '50px', height: '50px', background: `rgba(216, 235, 0, ${transparency}`}"><strong>{{value}}</strong></div>
    </div>
    <div v-else class="d-flex justify-center py-1">
        <div style="width: 50px; height: 50px;"/>
    </div>
</template>

<script>
    export default {
        name: 'WorklogCell',
        props: ['value', 'item'],
        computed: {
            transparency: function () {
                const values = []
                let uniq = []
                let factor = 0
                const availablePercentage = 90
                const minPercentage = 100 - availablePercentage
                Object.entries(this.item).forEach(entryValue => {
                    if (typeof entryValue[1] === 'number' && entryValue[1] >= 1) {
                        values.push(entryValue[1])
                    }
                })
                values.sort((a, b) => a - b)
                uniq = [...new Set(values)]
                factor = availablePercentage / (uniq.length - 1)
                if (uniq.length > 1) {
                    const checkIndex = uniq.findIndex(number => number === this.value)
                    return (factor * checkIndex + minPercentage) / 100
                }
                return 1
            }
        }
    }
</script>
